import React, { Component } from 'react'
import RangeCalendar   from 'rc-calendar';
import 'rc-calendar/assets/index.css'
import { connect } from 'react-redux';
import moment from 'moment'
import '../../assets/styles/components/datepicker.scss'
import zh_CN from 'rc-calendar/lib/locale/zh_CN';
import zh_TW from 'rc-calendar/lib/locale/zh_TW';
import en_US from 'rc-calendar/lib/locale/en_US';
import  'moment/locale/zh-cn';
import  'moment/locale/zh-hk';
import  'moment/locale/en-au';

class DatePicker extends Component{
    constructor(props) {
        super(props);
        this.state ={
            localelanguage :en_US,
            // disableDateList:""
        }
    }

    disabledDate = (current) => {
        const currentDate = current.format('YYYY-MM-DD')
        const disableDateList = this.props.data.map(item=>item.label)
        // this.setState({disableDateList})
        return  !disableDateList.includes(currentDate)
        // return current < moment().subtract(1, 'day') ||  current.isoWeekday() == 6 || current.isoWeekday() == 7
    }

    onOK = (value) =>{
        this.props.setGoodTillDate(value.format().slice(0,10));
        // this.setState({selectedValue : value})
    }
    
    Stopbubbling=(e)=>{
        e.preventDefault()
    }

    render(){
        const {localelanguage , disableDateList} =this.state
        return(
            <RangeCalendar 
            showDateInput={false}
            showOk={false}
            showToday={false}
            disabledDate={this.disabledDate}
            // moment={moment()}
            onSelect= {this.onOK}
            locale={localelanguage}
            defaultValue={moment(this.props.defaultValue)}
            // defaultSelectedValue={moment(this.props.defaultValue)}
            />
        )
    }

    componentDidMount() {
        document.getElementsByClassName('rc-calendar')[0].addEventListener('mousedown' , this.Stopbubbling)
        const {language} = this.props
        if(language){
            if(language.lang == 'zh_CN'){
                this.setState({
                localelanguage : zh_CN
                })
                moment.locale('zh_cn')
            }else if(language.lang == 'zh_TW'){
                this.setState({
                    localelanguage : zh_TW
                })
                moment.locale('zh_hk')
            }else{
                this.setState({
                    localelanguage : en_US
                })
                moment.locale('en-au')
            }
        }
      }

      UNSAFE_componentWillMount() {
        const { language } = this.props;
        if (language.lang == "zh_CN") {
          moment.locale("zh_cn");
        } else if (language.lang == "en_US") {
          moment.locale("en-au");
        } else {
          moment.locale("zh_hk");
        }
      }
    componentWillUnmount(){
        document.getElementsByClassName('rc-calendar')[0].removeEventListener('mousedown' , this.Stopbubbling)
    }
    componentDidUpdate(preProps){
        const {language} = this.props
        if(language != preProps.language){
            if(language.lang == 'zh_CN'){
                this.setState({
                localelanguage : zh_CN
                })
                moment.locale('zh_cn')
            }else if(language.lang == 'zh_TW'){
                this.setState({
                    localelanguage : zh_TW
                })
                moment.locale('zh_hk')
            }else{
                this.setState({
                    localelanguage : en_US
                })
                moment.locale('en-au')
            }
        }
    }
}

export default connect(
    state => ({
        language: state.app.language,
      }),
)(DatePicker)